export default __webpack_public_path__ + "static/media/Gesture_white_Tap-17.3f71e2df.svg";